import React from 'react';
import type { BaseModalProps } from '../../ui/uiSlice';
import OrganizationOnboardingStepAuth from './OrganizationOnboardingStepAuth';
import OrganizationOnboardingStepInvite from './OrganizationOnboardingStepInvite';
import OrganizationOnboardingStepProfile from './OrganizationOnboardingStepProfile';
import OrganizationOnboardingStepTeam from './OrganizationOnboardingStepTeam';

const STEPS = [
  { name: 'Authentication', component: OrganizationOnboardingStepAuth },
  { name: 'Team', component: OrganizationOnboardingStepTeam },
  { name: 'Profile', component: OrganizationOnboardingStepProfile },
  { name: 'Invite', component: OrganizationOnboardingStepInvite },
] as const;

export const AUTHENTICATION_STEP = 0;
export const INVITE_STEP = 1;

interface OrganizationOnboardingModalProps extends BaseModalProps {
  step: number;
  onComplete: () => void;
  onUpdateStep: (step: number) => void;
}

const OrganizationOnboardingModal = ({
  step,
  onComplete,
  onUpdateStep,
}: OrganizationOnboardingModalProps) => {
  const { component: StepComponent } = STEPS[step] ?? {};

  if (!StepComponent) {
    return null;
  }

  const onNext = () => {
    if (step === STEPS.length - 1) {
      onComplete();
    } else {
      onUpdateStep(step + 1);
    }
  };

  const onPrevious =
    step > 0
      ? () => {
          onUpdateStep(step - 1);
        }
      : null;

  return (
    <StepComponent
      lastStep={step === STEPS.length - 1}
      step={step}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  );
};

export default OrganizationOnboardingModal;
